import { styled } from "styled-components";

export const MyInfo = styled.span`
  font-size: 18px;
`;
